import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { ChangeTenantModal } from './ChangeTenantModal';

const ChangeTenantModalBridge = react2angular(ChangeTenantModal, [
  'activeTenantId',
  'userBusinessId',
  'onClose'
]);

export default ChangeTenantModalBridge;
